import * as helper from '../../../../../VX/View/Assets/Js/helper';

// Put your Javascript here - You can use ES2015 Javascript, because we use Webpack with Babel
require('./../Sass/base.scss');

// Require babel polyfill before anything else so stupid IE can handle modern stuff like Symbols etc.
if (!(global as any)._babelPolyfill) {
	require('babel-polyfill');
}

helper.onDocumentLoaded(() => {
	const link = document.querySelector('a');
	const click = helper.getData(link, 'click');
	helper.addClickListener(link, () => {
		fetch(click);
	})
})
